import {
  name
} from "file-loader";
import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
// import head from "../components/head";
const index = r => require.ensure([], () => r(require('../pages/index')), 'index');
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [{
    path: "/pages/index",
    component: index
  },
  // 重定向
  {
    path: '/',
    redirect: '/pages/index'
  },
]
console.log('routes', routes)
var router = new VueRouter({
  routes
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js